import React from 'react';
import FeaturedImage from '../FeaturedImage';

function post(props) {
  const {
    post,
    postType,

  } = props;

  let featuredImage;
  let capacity;
  let open;
  let favorite;

  if (post.hasOwnProperty('_embedded') && post._embedded.hasOwnProperty('wp:featuredmedia')) {
    featuredImage = <a href={post.link} title={post.title.rendered}>
        <figure className="eight29-featured-image">
            <FeaturedImage
            imageSize={'ranch-article'}
            image={post._embedded['wp:featuredmedia']}
            srcset={post.featured_image_srcset}
            ></FeaturedImage>
        </figure>
      </a>
  }

  if ( post.acf.ranch_guest_capacity ) {
    capacity = <div className="eight29-ranch-capacity">Guest Capacity: {post.acf.ranch_guest_capacity}</div>
  }

  if ( post.acf.ranch_dates_open ) {
    open = <div className="eight29-ranch-capacity">Open: {post.acf.ranch_dates_open}</div>
  }

  const is_favorite = document.cookie.split('; ').reduce( (p,v) => {
    const cookie = v.split('=');
    return cookie[0] == 'favorite_ranches' ? JSON.parse(cookie[1]).includes( props.post.id ) ? 'is-favorite' : '' : '';
  });

  favorite = <button type="button" aria-label="Mark as favorite" className={`favorites-button eight29-ranch-favorite ${is_favorite}`} data-ranch={post.id} data-favorite="">
        <svg className="heart-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className="path-inner" d="M16.5 3C14.76 3 13.09 3.81 12 5.09C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.42 2 8.5C2 12.28 5.4 15.36 10.55 20.04L12 21.35L13.45 20.03C18.6 15.36 22 12.28 22 8.5C22 5.42 19.58 3 16.5 3Z" fill="none"/>
            <path className="path-outer" fillRule="evenodd" clipRule="evenodd" d="M12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.2769 18.6056 15.3549 13.4627 20.0185L13.45 20.03L12 21.35L10.55 20.04L10.5105 20.0041C5.38263 15.3442 2 12.2703 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09ZM12 18.65L12.1 18.55C16.86 14.24 20 11.39 20 8.5C20 6.5 18.5 5 16.5 5C14.96 5 13.46 5.99 12.94 7.36H11.07C10.54 5.99 9.04 5 7.5 5C5.5 5 4 6.5 4 8.5C4 11.39 7.14 14.24 11.9 18.55L12 18.65Z" fill="black"/>
        </svg>
    </button>

  return (
    <article id={`${postType}-${post.id}`} className="eight29-post eight29-ranch-card">

        {featuredImage}

        <div className="eight29-ranch-body">
          <div className="eight29-ranch-wrapper">
            <div className="eight29-ranch-location">
                {post.acf.ranch_location}
            </div>

            <h4 className="eight29-ranch-title"><a href={post.link} title={post.title.rendered} dangerouslySetInnerHTML={{__html: post.title.rendered}}></a></h4>

            <div className="eight29-ranch-detail">
                {capacity}
                {open}
            </div>
          </div>

          <div className="eight29-ranch-btn">
              <a href={post.link} title={post.title.rendered} className="eight29-ranch-more">Learn More</a>
              <a href={post.acf.ranch_website} title={`${post.title.rendered} Website`} className="eight29-ranch-website" target="_blank" rel="noopener">Visit Website</a>
          </div>
        </div>

        {favorite}
    </article>
  );
}

export default post;